import { postAsyncWithTokenFormData } from "./requestWithToken";

// const campaignApi = process.env.REACT_APP_SEO_SERVICE_API;
// const graphqlQueryUrl = `${campaignApi}/seo/campaigns/graphql-query`;
const graphqlQueryUrl = `${process.env.REACT_APP_API}graphql-query`;

export async function getCollectionsRes(first, searchName, after) {
  const graphql_query = `query CollectionList {
  collections(first: ${first}, query: "${searchName}", after: ${(after && `"${after}"`) || null}) {
    nodes {
      id
      handle
      title
      image {
        id
        url
      }
      productsCount {
        count
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}`;
  try {
    const response = await postAsyncWithTokenFormData(graphqlQueryUrl, {
      graphql_query,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

export async function getProductsRes(first, searchName, after) {
  const graphql_query = `query ProductList {
  products(first: ${first}, query: "${searchName}", after: ${(after && `"${after}"`) || null}) {
    nodes {
      id
      handle
      title
      featuredMedia {
        preview {
          image {
            url
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}`;
  try {
    const response = await postAsyncWithTokenFormData(graphqlQueryUrl, {
      graphql_query,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

export async function getArticlesRes(first, query, after) {
  const graphql_query = `query articleList {
  articles(first: ${first}, query: "${query}", after: ${(after && `"${after}"`) || null}) {
    nodes {
      id
      handle
      title
      image {
        url
      }
      blog{
        id
        handle
        title
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}`;
  try {
    const response = await postAsyncWithTokenFormData(graphqlQueryUrl, {
      graphql_query,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}
